import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface FAQItem {
  id: number;
  question: string;
  answer: string;
  category: string;
  isExpanded?: boolean;
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  faqs: FAQItem[] = [
    {
      id: 1,
      question: 'What is MahaAgX',
      answer: 'Maharashtra Agriculture Data Exchange (MahaAgX) is a unified platform that enables secure and scalable data exchange across sectors. It offers access to curated data banks, AI models, real-world applications, and a Sandbox IDE with GPU-based compute to drive data-driven innovation across Maharashtra.',
      category: 'general',
      isExpanded: true
    },
    {
      id: 2,
      question: 'Who can use MahaAgX?',
      answer: 'MahaAgX is accessible to researchers, innovators, policymakers, and organizations working in agriculture and related sectors across Maharashtra.',
      category: 'general',
      isExpanded: false
    },
    {
      id: 3,
      question: 'What can I do on MahaAgX?',
      answer: 'You can access curated datasets, utilize AI models, develop and test applications in the Sandbox IDE, and collaborate on data-driven projects.',
      category: 'general',
      isExpanded: false
    },
    {
      id: 4,
      question: 'Is MahaAgX open to individuals or only Organisations?',
      answer: 'MahaAgX is open to both individuals and organizations. We welcome researchers, developers, and institutions to leverage our platform.',
      category: 'general',
      isExpanded: false
    },
    {
      id: 5,
      question: 'How is MahaAgX different from a traditional data portal?',
      answer: 'MahaAgX goes beyond traditional data portals by offering integrated AI models, GPU-based compute resources, and a collaborative sandbox environment for innovation.',
      category: 'general',
      isExpanded: false
    },
    {
      id: 6,
      question: 'Is there a fee to access MahaAgX?',
      answer: 'Basic access to MahaAgX is free. Premium features and additional compute resources may have associated costs.',
      category: 'general',
      isExpanded: false
    },
    {
      id: 7,
      question: 'Can I suggest new features or improvements for MahaAgX?',
      answer: 'Yes! We welcome feedback and suggestions. Please use the Contact Us section to share your ideas for improving the platform.',
      category: 'general',
      isExpanded: false
    }
  ];

  get filteredFaqs(): FAQItem[] {
    return this.faqs;
  }

  toggleFaq(faqId: number): void {
    const faq = this.faqs.find(f => f.id === faqId);
    if (faq) {
      // If clicking on an already expanded FAQ, close it
      if (faq.isExpanded) {
        faq.isExpanded = false;
      } else {
        // Close all other FAQs first
        this.faqs.forEach(f => {
          f.isExpanded = f.id === faqId;
        });
      }
    }
  }
}

